import React, { useState, useEffect } from "react";
import { Button, Flex, Text, Textarea } from "@chakra-ui/react";
import { useRecoilValue } from "recoil";
import { SOLUTION_SUBJECT_ID, CURRENT_CONTENT } from "../../../recoilState/Atoms";
import { editSubject } from "../../../services/SolutionDetailAPI";

const SubjectModifyModal = (props) => {
    const subjectId = useRecoilValue(SOLUTION_SUBJECT_ID);
    const currentContent = useRecoilValue(CURRENT_CONTENT);
    const [content, setContent] = useState("");

    const handleChangeContent = (event) => setContent(event.target.value);

    useEffect(() => {
        setContent(currentContent);
    }, []);

    return (
        <Flex alignItems="center" direction="column">
            <Text fontSize="5xl" as="b" mb="30px" mt="10px">
                구성요소명 수정
            </Text>
            <Textarea
                htmlSize={15}
                fontSize="20px"
                textAlign="top"
                h="100px"
                w="300px"
                value={content}
                placeholder="텍스트를 입력해주세요"
                _placeholder={{ opacity: 0.4, color: "inherit" }}
                onChange={handleChangeContent}
                size="sm"
            />

            <Flex mt="30px" mb="10px">
                <Button
                    fontSize="xl"
                    size="md"
                    colorScheme="red"
                    mr={3}
                    onClick={() => {
                        props.setIsModalOpen(false);
                    }}
                >
                    닫기
                </Button>
                <Button
                    fontSize="xl"
                    size="md"
                    colorScheme="gray"
                    onClick={() => {
                        editSubject(subjectId, content).then(() => {
                            props.setUpdateState(Math.random());
                            alert("구성요소명 수정이 완료되었습니다!");
                            props.setIsModalOpen(false);
                        });
                    }}
                >
                    수정
                </Button>
            </Flex>
        </Flex>
    );
};

export default SubjectModifyModal;
